import { render, staticRenderFns } from "./SihaoLayout.vue?vue&type=template&id=377c919c&scoped=true&"
import script from "./SihaoLayout.vue?vue&type=script&lang=js&"
export * from "./SihaoLayout.vue?vue&type=script&lang=js&"
import style0 from "./SihaoLayout.vue?vue&type=style&index=0&id=377c919c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377c919c",
  null
  
)

export default component.exports